module.exports = __webpack_public_path__ + "img/coop.60c99fd7.webp";